/**
 * OfflineBanner - Global offline notification
 *
 * Shows a fixed banner at the top when user goes offline.
 * Disappears automatically when connection is restored.
 */

import { useNetworkStatus } from '@/hooks';

export function OfflineBanner() {
  const isOnline = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-charcoal-800 text-white text-center py-2 text-sm z-50">
      Offline. Try again when connected.
    </div>
  );
}

export default OfflineBanner;
